import api from './api';
import { AnalyticsSummary } from '../types/crossSystem';

export const analyticsService = {
  getPersonaSummary: async (params?: Record<string, any>): Promise<AnalyticsSummary> => {
    const resp = await api.get('/analytics/cross-system/persona/summary', { params });
    return resp.data;
  },

  getPersonaDetail: async (personaId: string) => {
    const resp = await api.get(`/analytics/cross-system/persona/${personaId}/detail`);
    return resp.data;
  },

  getWorkflowSummary: async (): Promise<AnalyticsSummary> => {
    const resp = await api.get('/analytics/cross-system/workflow/summary');
    return resp.data;
  },

  getWorkflowDetail: async (workflowId: string) => {
    const resp = await api.get(`/analytics/cross-system/workflow/${workflowId}/detail`);
    return resp.data;
  },

  getArtifactorySummary: async (): Promise<AnalyticsSummary> => {
    const resp = await api.get('/analytics/cross-system/artifactory/summary');
    return resp.data;
  },

  getArtifactoryDetail: async (manifestId: string) => {
    const resp = await api.get(`/analytics/cross-system/artifactory/${manifestId}/detail`);
    return resp.data;
  },

  getEvents: async (params?: {
    category?: string;
    event_type?: string;
    target_type?: string;
    target_id?: string;
    limit?: number;
    from?: string;
    to?: string;
  }) => {
    const resp = await api.get('/analytics/cross-system/events', { params });
    return resp.data;
  },
};
